<template>
  <div>
    <div class="back-btn-container">
      <back-btn />
      <h3 class="title-page">{{ $tc("orderHistory", 0) }}</h3>
    </div>
    <div class="mdm-table">
      <div class="admin_container">
        <div class="d-flex justify-space-between mb-3"></div>
        <table-with-filter
          fixed-header
          :headers="headers"
          :height="$vuetify.breakpoint.height - 205"
          :items="histories"
        >
          <template #filter.orderNum>
            <div class="pa-1">
              <custom-input-text
                v-model="historyFilter.numb"
                class="user_input no-margin"
                clearable
                @input="getHistoryWithFilter"
              />
            </div>
          </template>
          <template #filter.itemNumb>
            <div class="pa-1">
              <custom-input-text
                v-model="historyFilter.itemNumb"
                clearable
                @input="getHistoryWithFilter"
                class="user_input no-margin"
              />
            </div>
          </template>
          <template #filter.state>
            <div class="pa-1">
              <custom-select
                v-model="historyFilter.state"
                :items="orderItemStatus"
                clearable
                item-text="text"
                item-value="value"
                @input="getHistoryWithFilter"
                class="user_input no-margin"
              />
            </div>
          </template>

          <template #item.state="{ item }">
            <div :class="{ 'notify-text': item.changes.indexOf('state') > -1 }">
              <span class="notify-text-element">{{ $t(item.state) }}</span>
            </div>
          </template>
          <template #item.updatedDate="{ item }">
            <div>
              {{ item.updatedAt | fullTimeParse }}
            </div>
          </template>
          <template #item.statusChangedUser="{ item }">
            <div
              :class="{
                'notify-text': item.changes.indexOf('statusChangedUser') > -1,
              }"
            >
              <span class="notify-text-element">{{
                item.statusChangedUser
              }}</span>
            </div>
          </template>
          <template #item.productName="{ item }">
            <div
              :class="{ 'notify-text': item.changes.indexOf('product') > -1 }"
            >
              <span class="notify-text-element">{{ item.productName }}</span>
            </div>
          </template>
          <template #item.count="{ item }"
            >{{ item.count }} / {{ item.given }}</template
          >
          <template #item.action="{ item, index }">
            <v-btn
              v-if="index !== 0 && $can($permissions['RESTORE'])"
              class="new_style"
              @click="onRestore(index)"
            >
              <vue-icon icon="newTimeIcon"></vue-icon>
            </v-btn>
            <v-btn
              class="new_style"
              v-if="item.signed"
              @click="showHistorySigned(item)"
            >
              <vue-icon icon="newFileEdit"></vue-icon>
            </v-btn>
          </template>
        </table-with-filter>
      </div>
      <warning-dialog
        @apply="PrevChangeOrder"
        @cancel="selectedHistoryIndex = null"
        v-model="warningDialog"
        description="doYouWantGoBack"
        yes-text="yes"
      ></warning-dialog>
      <SignedInfoDialog ref="signedInfoDialog"></SignedInfoDialog>
    </div>
  </div>
</template>

<script>
import { debounce, getQueryByKey, trueSet } from "@/utils/pureFunctions";
import BackBtn from "@/components/ui/BackBtn";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import { orderItemStatus, SIGNED_USER_DATA_TYPE } from "@/utils/constants";
import WarningDialog from "@/components/ui/prompt/warning-dialog";
import SignedInfoDialog from "@/components/history/SignedInfoDialog.vue";

export default {
  data() {
    return {
      selectedHistoryIndex: null,
      warningDialog: false,
      isShowFilter: false,
      historyFilter: {
        numb: null,
        itemNumb: null,
        orderId: null,
        fromDate: null,
        toDate: null,
        state: null,
      },
      histories: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("requestNumber"),
          value: "orderNum",
        },
        {
          text: this.$t("productName"),
          value: "productName",
        },
        {
          text: this.$t("orderRequestItemNumber"),
          value: "itemNumb",
        },
        {
          text: this.$t("count"),
          value: "count",
        },
        {
          text: this.$t("status"),
          value: "state",
        },
        {
          text: this.$t("updatedDate"),
          value: "updatedDate",
        },
        {
          text: this.$t("updatedByUser"),
          value: "statusChangedUser",
        },
        {
          text: this.$t("action"),
          value: "action",
        },
      ];
    },
    orderItemStatus() {
      return Object.keys(orderItemStatus).map((item) => {
        return {
          text: this.$t(item),
          value: item,
        };
      });
    },
  },
  methods: {
    onRestore(index) {
      this.selectedHistoryIndex = index;
      this.warningDialog = true;
    },
    async showHistorySigned(item) {
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.get("history/signed-user", {
          params: {
            dataType: SIGNED_USER_DATA_TYPE.OrderItem,
            id: item.id,
            revision: item.revision,
          },
        });
        const { signedInfoDialog } = this.$refs;
        signedInfoDialog.open(data);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async PrevChangeOrder() {
      this.showLoading();
      try {
        await this.$http.post("backend/previous-changes-order-item", {
          objectId: this.histories[this.selectedHistoryIndex].id,
          revision: this.histories[this.selectedHistoryIndex].revision,
        });
        await this.getHistories();
      } catch (err) {
        this.setResponseError({ error: err });
      } finally {
        this.clearLoading();
      }
    },

    getHistoryWithFilter: debounce(function () {
      const query = this.historyFilter;
      this.$router.replace({ query }).catch(() => {});
      this.getHistoryWithLoading();
    }, 300),
    async getHistories() {
      const params = { ...this.historyFilter };
      try {
        const {
          data: { data },
        } = await this.$http.get("history/office/order-items", {
          params,
        });
        this.histories = data.map((item) => {
          item.signed = trueSet(item.signed);
          return item;
        });
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async getHistoryWithLoading() {
      this.showLoading();
      await this.getHistories();
      this.clearLoading();
    },
  },
  components: {
    SignedInfoDialog,
    WarningDialog,
    TableWithFilter,
    BackBtn,
  },
  async created() {
    const { query } = this.$route;
    this.historyFilter = getQueryByKey(this.historyFilter, query);
    this.showLoading();
    await this.getHistories();
    this.clearLoading();
  },
};
</script>
